

<script>
    import BaseModal from './BaseModal';
	export default {
		props : ['totalArea', 'areaIdArray'],
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'ConfirmQuoteModal',
			}
		},
		created(){
    		this.confirmSurvey()
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods : {
			confirmSurvey(){
					let surveyData = {
					areaIds : this.areaIdArray,
					totalArea : this.totalArea
				}
				this.$store.dispatch('createSurvey', surveyData)
				.then((response) => {
					this.$toasted.clear()

					if(response.confirmation === 'success'){
						this.$toasted.success("Success!", {
			                theme: 'bubble',
			                position: 'bottom-center',
			                duration: 5000
			            })
						this.$store.commit('closeModal', '');
					}

				})
				.catch((err) => {
					console.log(err);
					this.$toasted.clear();
					this.$toasted.error(err.message, {
			            theme: 'bubble',
			            position: 'bottom-center',
			            duration: 5000
			        })
			        this.$store.commit('closeModal', '');
				})
			},


			closeModal(){
				this.$store.commit('closeModal', '');
			},
		},			
		
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/ConfirmQuoteModal.vue